import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../models/http-models/api-response';
import { API_CONSTANTS } from '../../base/api-constants';
import { BaseService } from '../../base/base-service';


@Injectable({
  providedIn: 'root'
})
export class ModerationService extends BaseService {

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  
  GetAccountViaToken(): Observable<HttpEvent<ApiResponse>> {
    return this.get(API_CONSTANTS.Moderation.GetUserAccountByToken);
  }

  login(model: any): Observable<HttpEvent<ApiResponse>> {
    return this.post(API_CONSTANTS.Moderation.Login, model);
  }


}
